<!-- Show photo. -->
<div class="modal-content">
    <div class="modal-header">
        <div class="row">
            <div class="col-12 text-center">
                <label for="">PHOTO: {{photo.fileName}}</label>
            </div>
        </div>
        <button type="button" class="close" (click)="dismiss()">
            <img title="Close"
                src="https://s3-ap-southeast-1.amazonaws.com/finanma-static/assets/images/icon/close.png">
        </button>
    </div>
    <div class="modal-body horizon-mobile">
        <div class="row">
            <div class="col-12 text-center ">
                <div class="view-photo">
                    <img [src]="photo.url" [ngClass]="getRotate()">
                </div>
                <div class="photo-control">
                    <a [ngClass]="rotatePhoto === 1 && 'disabled-button'" (click)="rotatePrevious()">
                        <img src="./assets/images/icon/rotate-left.svg" alt="" title="Quay trái">
                    </a>
                    <a [ngClass]="rotatePhoto === 4 && 'disabled-button'" (click)="rotateNext()">
                        <img src="./assets/images/icon/rotate-right.svg" alt="" title="Quay phải">
                    </a>
                    <a (click)="download()">
                        <img src="./assets/images/icon/download.svg" title="Tải về">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer">
        <button class="btn btn--trans" (click)="dismiss()">Đóng</button>

    </div> -->
</div>